export const signs: string[] = ["+", "="]

type Signs = typeof signs

type Sign = Signs[number]

export default Sign
